<template>
  <div class="modal fade" id="openAttendDialog" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="example-Modal3">报名招聘会</h5>
          <button type="button" class="close" ref="closeMyApply" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">

          <div class="complete-content">
            <div v-for="(item,idx) in allAttends " :class=" item.id === selectedId ?'attend-list selected':'attend-list'"  :key="idx"  v-on:click="setSelectTarget(item)">
              <div style="padding: 10px 20px;">
                <div class="fair-info">
                  <div class="fair-name"> <span v-text="item.title"></span> <span v-if="item.stateStr" class="attends" v-text="item.stateStr"></span></div>
                  <div class="fair-scale">展位数：<span v-text="item.scanInfo"></span></div>
                  <div class="fair-host">
                    <div class="host-ent">主办方：<span v-text="item.sponsor"></span></div>
                    <div class="host-time">主办时间：<span v-text="timeHelp(item.startTime)"></span>至<span v-text="timeHelp(item.endTime)"></span></div>
                  </div>
                  <div class="form-group" style="margin-bottom:1px" v-if="item.fairType==2">
                    <label class="field-label">拟对接院系：</label>
                    <input type="text" style="width:70%" class="field-input" :id="'school_'+item.id" placeholder="如有需要，计划与该高校哪个院系对接"> 
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-twitter" v-on:click="addAttend()">确定</button>
          <button type="button" class="btn btn-secondary" data-dismiss="modal">取消</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import {getAllAttendFair, attendFair} from '@/api/fair'
    import Toastr from "toastr2";
    import {parseTime} from "@/utils/datetime";

    export default {
        name: "fair_index",
        data() {
            return {
                selectedId:"",
                topList: [],
                allAttends: [],
                loginType:1
            }
        },
        mounted() {
        },
        methods: {
            openAttend(){
                getAllAttendFair().then(response => {
                    this.allAttends = response.result
                }).catch(error => {
                    this.allAttends = []
                })
            },
            setSelectTarget(item){
                const toast = new Toastr()
                if(item.attendState == null  ){
                    this.selectedId = item.id
                }else {
                    toast.warning('数据处理中，不要重复申请哦!!')
                    return
                }
            },
            addAttend(){
                const toast = new Toastr()
                var data = {}
                if(this.selectedId == ""){
                    toast.warning('请选择要报名的招聘会!!')
                    return
                }
                data["fairId"] = this.selectedId;
                data["attendType"] = 1;
                // data["juniorNum"] = $('#junior_'+this.selectedId).val();
                // data["undergraduateNum"] = $('#undergraduate_'+this.selectedId).val();
                // data["postgraduateNum"] = $('#postgraduate_'+this.selectedId).val();
                data["schoolInfo"]= $('#school_'+this.selectedId).val();
                attendFair(data).then(response => {
                    toast.success('报名成功')
                    $('#openAttendDialog').modal('hide');
                }).catch(error => {
                    toast.success('失败')
                    //this.allAttends = []
                })
            },
            timeHelp(time){
                var str = parseTime(time, "{y}年{m}月{d}日");
                return str;
            }
        },
        computed: {}
    }
</script>


<style scoped>

  .fair-info {
    /* float: left; */
    width: 100%;
    text-align: left;
  }

  .fair-name {
    height: 25px;
    line-height: 25px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: 500;
  }

  .fair-scale {
    height: 25px;
    line-height: 25px;
  }

  .fair-host {
    width: 100%;
    /* height: 25px; */
    line-height: 25px;
  }

  .host-ent {
    width: 100%;
    /* float: left; */
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .host-time {
    width: 100%;
    /* float: left; */
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

.complete-content{
display: flex;
flex-wrap: wrap;
/* padding-left: 1%; */
max-height: 500px;
overflow-y: auto;

}

.complete-content > .attend-list{
width: 100%;
/* height: 80px; */
margin:10px 20px;
text-align: center;
position: relative;
border: 1px #cccccc solid;
cursor: pointer;
}

.complete-content > .selected {
/* border: 1px solid #3F7C37; */
border: 1px solid #f8b62b;
background-color: #fef9ee;
/* overflow: hidden; */
}
/* .complete-content > .selected::before{
font: normal normal normal 14px/1 FontAwesome;
content: "\f046";
position: absolute;
font-size: 24px;
color: #fff;
right: 8px;
bottom: 5px;
z-index: 10;
}
.complete-content > .selected::after{
content:'';
position: absolute;
top:60px;
right: -60px;
width: 120px;
height: 120px;
background: #3F7C37;
transform:rotate(45deg);
} */

  .attends {
    background: #e3a930;
    border-color: #e3a930;
    border-radius: 5px;
    color: #fff;
    padding: 0px 2px 0px 2px;
    margin-left: 10px;
  }

  .modal-footer {
    justify-content: center;
  }

  .btn-twitter{
    background-color: #f8b62b;
    border: 1px solid #f8b62b;
    height: 30px;
    width: 80px;
    border-radius: 0px;
    line-height: 0px;
  }
  .btn-secondary{
    background-color: #f7f7f7 !important;
    background: #f7f7f7 !important;
    border: 1px solid #f7f7f7 !important;
    color: #666666;
    height: 30px;
    width: 80px;
    border-radius: 0px;
    line-height: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/views/fair/commons/attend.vue